var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgErrorIconRed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 32,
    viewBox: "0 0 36 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.1818 2.56372L35.104 24.9906C35.3884 25.66 35.5129 26.2043 35.5484 26.7698C35.6195 28.091 35.1574 29.3752 34.2509 30.3635C33.3443 31.3482 32.1179 31.9295 30.7848 32H4.7625C4.21148 31.9665 3.66046 31.8415 3.14499 31.6477C0.567647 30.6083 -0.676588 27.6841 0.372124 25.1491L13.3833 2.54786C13.8276 1.75338 14.5031 1.06812 15.3385 0.627722C17.7559 -0.712853 20.8309 0.167946 22.1818 2.56372ZM19.32 17.3434C19.32 18.189 18.6268 18.8954 17.7736 18.8954C16.9204 18.8954 16.2094 18.189 16.2094 17.3434V12.3599C16.2094 11.5126 16.9204 10.8273 17.7736 10.8273C18.6268 10.8273 19.32 11.5126 19.32 12.3599V17.3434ZM17.7736 24.9201C16.9204 24.9201 16.2094 24.2137 16.2094 23.3699C16.2094 22.5226 16.9204 21.8179 17.7736 21.8179C18.6268 21.8179 19.32 22.5067 19.32 23.3505C19.32 24.2137 18.6268 24.9201 17.7736 24.9201Z",
    fill: "#EB4E2C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgErrorIconRed);
export default __webpack_public_path__ + "static/media/error_icon_red.303a7f162d8249764565c26089075e56.svg";
export { ForwardRef as ReactComponent };